// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.font-small[data-v-ee8ffdba] {\n  font-size: 12px;\n}\n.stack[data-v-ee8ffdba] {\n  font-size: 14px;\n  user-select: all;\n  border: 1px solid var(--v-subtle-darken2);\n  border-radius: 4px;\n  padding: 10px;\n  margin: 3px 0;\n}\n", ""]);
// Exports
module.exports = exports;
